var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 767,
    height: 579,
    viewBox: "0 0 767 579",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M360.046 172.976C360.676 170.34 408.247 99.5841 408.247 99.5841L409.967 118.311L485.403 4.85848L484.448 35.3403L558.062 -96.4636C558.062 -96.4636 560.806 -52.5916 565.907 -60.4132C571.027 -68.2653 667.962 -243.804 667.962 -243.804L972 212L684.744 256.082L693.839 271.843L603.859 268.621L617.245 287.203L506.155 284.008L526.971 305.657L460.434 295.933L465.223 307.058L413.09 297.51C413.09 297.51 339.328 259.515 360.043 172.964L360.046 172.976Z",
    fill: "url(#paint0_linear_692_8626)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M371.542 129.25L410.635 68.4112C410.635 68.4112 409.444 86.9866 413.191 86.1711C416.939 85.3556 458.471 5.66928 458.471 5.66928L417.858 65.5311C417.858 65.5311 416.712 42.2309 415.029 46.522C413.347 50.8131 371.542 129.25 371.542 129.25Z",
    fill: "#E9543E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M481.13 308.189L547.231 317.354L536.092 296.228L624.406 299.251L554.344 307.956L561.03 332.667L481.13 308.189Z",
    fill: "#EA5640"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.568 504.336C136.348 503.373 263.39 434.685 265.169 433.722C269.396 431.442 281.175 445.049 291.487 464.117C301.798 483.186 306.729 500.494 302.505 502.787C300.726 503.75 173.684 572.438 171.904 573.4C167.678 575.681 155.899 562.074 145.587 543.005C135.275 523.937 130.344 506.628 134.571 504.348L134.568 504.336Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M276.188 472.392C286.499 491.46 298.278 505.067 302.505 502.787C306.732 500.507 301.801 483.198 291.487 464.117C281.175 445.049 269.396 431.442 265.169 433.722C260.942 436.003 265.873 453.311 276.188 472.392Z",
    fill: "#29ABE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M284.168 362.851C284.168 362.851 288.243 368.048 280.103 373.208L271.966 378.38C271.966 378.38 261.554 380.738 258.899 371.961C239.734 385.198 221.32 380.78 208.576 360.514C195.845 340.245 210.093 323.656 216.328 318.283C212.471 308.734 211.911 303.152 223.904 294.419C240.933 292.65 284.181 362.849 284.181 362.849L284.168 362.851Z",
    fill: "#FFCA27"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.988 316.343C221.439 311.166 218.738 302.543 223.644 294.607C223.736 294.547 223.813 294.478 223.892 294.422C227.526 294.05 232.357 296.95 237.706 301.751L285.175 366.217C285.141 367.925 284.298 370.123 281.32 372.368C277.172 372.969 271.744 371.652 267.076 366.675C248.728 364.362 239.828 356.291 233.511 346.44C227.194 336.59 225.38 322.423 226.963 316.348L226.988 316.343Z",
    fill: "#FFDE59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M287.285 466.392C296.09 482.688 306.156 494.313 309.774 492.361C313.379 490.412 309.165 475.617 300.362 459.334C291.557 443.038 281.491 431.413 277.873 433.365C274.268 435.314 278.482 450.109 287.285 466.392Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M286.451 490.097C287.854 488.967 344.49 454.336 344.49 454.336C363.752 454.475 388.266 427.763 386.182 399.25C386.77 392.633 375.002 387.253 375.002 387.253C375.947 376.685 363.157 371.841 363.157 371.841C362.482 360.2 350.581 358.538 350.581 358.538C354.701 341.759 332.043 345.617 319.187 352.85C306.33 360.083 301.698 367.292 299.763 376.858C297.828 386.424 280.155 395.451 297.644 427.663C284.373 438.701 269.477 444.559 269.477 444.559C269.477 444.559 268.895 482.287 286.436 490.087L286.451 490.097Z",
    fill: "#FCC39E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M339.959 448.728C339.959 448.728 283.324 483.36 281.921 484.489C280.284 483.759 278.798 482.761 277.451 481.563C279.739 485.343 282.669 488.408 286.449 490.084C287.851 488.955 344.487 454.324 344.487 454.324C363.749 454.462 388.263 427.75 386.179 399.238C386.455 396.117 359.219 448.855 339.957 448.716L339.959 448.728Z",
    fill: "#FCC39E"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M321.718 415.346C329.164 435.312 340.633 440.823 350.835 437.02C361.036 433.217 366.11 421.542 358.677 401.573C351.231 381.606 336.93 368.495 326.729 372.298C316.527 376.101 314.285 395.376 321.718 415.346Z",
    fill: "url(#paint1_radial_692_8626)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M316.511 348.971C318.214 351.086 377.861 412.116 377.861 412.116C377.861 412.116 369.79 432.202 358.589 429.969C347.388 427.736 289.549 364.192 289.549 364.192L316.508 348.958L316.511 348.971Z",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M367.553 417.173C367.553 417.173 312.399 360.738 306.653 354.531L316.508 348.958C318.211 351.073 377.859 412.104 377.859 412.104C377.859 412.104 370.235 431.059 359.532 430.091C364.482 424.762 367.538 417.163 367.538 417.163L367.553 417.173Z",
    fill: "#666666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M279.2 370.801L327.422 343.077C327.422 343.077 333.653 340.151 329.9 328.434C326.147 316.718 288.981 254.628 273.806 260.586C258.644 266.542 223.649 297.876 223.649 297.876C223.649 297.876 222.019 308.24 229.03 314.786C225.325 340.869 244.012 363.191 268.598 365.311C272.77 370.774 279.19 370.816 279.19 370.816L279.2 370.801Z",
    fill: "#F15B40"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M325.822 343.661C325.822 343.661 314.08 346.517 311.788 337.91C296.086 341.628 268.269 290.691 271.534 280.627C265.759 273.327 269.862 263.865 273.813 260.558",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M271.522 280.629L229.04 314.771",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M311.776 337.913L268.608 365.296",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M226.988 316.343C226.007 317.066 224.23 318.159 221.769 318.695C219.77 319.13 218.059 319.018 216.953 318.867",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M266.057 367.46L260.637 370.091",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M211.521 323.424C211.521 323.424 205.605 344.637 222.472 363.168C236.174 378.215 247.84 376.697 247.84 376.697",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M319.423 333.854C319.423 333.854 365.47 308.461 411.17 309.127C380.845 287.493 335.506 227.221 338.841 182.968C329.36 222.187 288.586 269.105 276.631 273.866C273.611 293.598 300.884 336.502 319.425 333.867L319.423 333.854Z",
    fill: "#E6E6E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M380.619 279.6C390.982 292.05 401.787 302.442 411.157 309.129C365.47 308.461 319.41 333.857 319.41 333.857C310.983 335.05 300.759 326.847 292.391 315.69C320.715 301.376 349.912 288.912 380.607 279.603L380.619 279.6Z",
    fill: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M441.913 313.048C460.844 300.257 454.144 257.26 426.948 217.011C399.752 176.763 362.36 154.505 343.429 167.297C324.498 180.088 331.198 223.085 358.394 263.333C385.59 303.582 422.983 325.84 441.913 313.048Z",
    fill: "#666666"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M436.817 300.545C451.635 290.532 444.914 254.691 421.806 220.492C398.697 186.293 367.952 166.686 353.134 176.698C338.316 186.711 345.036 222.552 368.145 256.751C391.253 290.95 421.999 310.557 436.817 300.545Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M436.817 300.545C451.635 290.532 444.914 254.691 421.806 220.492C398.697 186.293 367.952 166.686 353.134 176.698C338.316 186.711 345.036 222.552 368.145 256.751C391.253 290.95 421.999 310.557 436.817 300.545Z",
    fill: "#EDEDEE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M396.038 249.634C380.405 226.491 361.269 210.036 345.944 204.906C343.979 191.728 346.192 181.395 353.129 176.719C367.944 166.705 398.693 186.323 421.795 220.519C444.9 254.727 451.625 290.563 436.807 300.565C432.017 303.805 425.558 303.942 418.235 301.493C415.993 286.503 408.346 267.836 396.038 249.634Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M383.89 406.212C383.89 406.212 357.007 431.478 347.16 423.861C333.802 429.751 331.43 413.56 333.771 410.852C324.866 414.779 322.013 400.59 324.734 398.061C326.909 395.73 336.35 387.893 336.35 387.893C336.35 387.893 325.942 397.602 318.899 391.39C310.512 383.991 318.642 373.496 329.442 359.096",
    fill: "#FCC39E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M383.89 406.212C383.89 406.212 357.007 431.478 347.16 423.861C333.802 429.751 331.43 413.56 333.771 410.852C324.866 414.779 322.013 400.59 324.734 398.061C326.909 395.73 336.35 387.893 336.35 387.893C336.35 387.893 325.942 397.602 318.899 391.39C310.512 383.991 318.642 373.496 329.442 359.096",
    fill: "#FCC39E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M383.89 406.212C383.89 406.212 357.007 431.478 347.16 423.861C333.802 429.751 331.43 413.56 333.771 410.852C324.866 414.779 322.013 400.59 324.734 398.061C326.909 395.73 336.35 387.893 336.35 387.893C336.35 387.893 325.942 397.602 318.899 391.39C310.512 383.991 318.642 373.496 329.442 359.096",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M321.388 418.518C321.659 415.974 327.291 398.329 318.914 384.06C330.482 384.015 344.602 381.806 343.588 370.893C342.574 359.98 325.404 363.023 321.127 362.187C316.847 361.339 308.898 356.371 302.197 363.756C295.494 371.128 285.483 390.118 291.428 410.163",
    fill: "#FCC39E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M321.388 418.518C321.659 415.974 327.291 398.329 318.913 384.06C330.482 384.015 344.602 381.806 343.588 370.893C342.857 362.967 333.578 362.409 326.935 362.363",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M374.818 394.946C372.733 399.011 369.69 403.965 365.269 409.022C358.861 416.369 352.089 421.022 347.157 423.848",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M361.201 378.063C360.404 378.367 350.186 401.694 346.389 404.626C342.604 407.556 333.759 410.855 333.759 410.855",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M349.259 362.385C349.259 362.385 343.068 379.327 339.28 384.704C335.492 390.081 329.332 392.377 329.332 392.377",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M408.37 255.258L383.169 279.294C383.169 279.294 359.315 255.65 352.357 235.878C370.751 227.401 382.827 220.665 382.827 220.665C382.827 220.665 404.802 239.105 408.382 255.256L408.37 255.258Z",
    fill: "#E6E6E6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M405.521 247.636C406.82 250.179 407.811 252.75 408.37 255.258L383.169 279.294C383.169 279.294 375.315 271.518 367.314 261.144C380.428 257.859 393.258 253.51 405.521 247.636Z",
    fill: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M387.176 243.896C393.887 253.818 402.807 259.517 407.106 256.606C411.405 253.695 409.457 243.299 402.742 233.365C396.03 223.444 387.11 217.744 382.811 220.655C378.513 223.566 380.461 233.962 387.176 243.896Z",
    fill: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M344.49 454.336C344.223 454.433 332.354 451.234 328.861 441.854",
    stroke: "black",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M261.272 442.328L277.871 433.352C274.265 435.301 278.479 450.097 287.282 466.38C296.088 482.675 306.153 494.3 309.771 492.349L293.173 501.325C289.567 503.274 279.489 491.651 270.684 475.356C261.878 459.06 257.667 444.277 261.272 442.328Z",
    fill: "#E6E6E6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M134.568 504.335L265.169 433.722C260.942 436.003 265.873 453.311 276.188 472.392C286.499 491.46 298.278 505.067 302.505 502.787L171.904 573.4C167.678 575.681 155.899 562.073 145.587 543.005C135.275 523.937 130.344 506.628 134.571 504.348L134.568 504.335Z",
    fill: "#0071BC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M239.568 509.183C224.181 507.913 213.006 525.037 198.238 525.896C180.288 525.772 164.429 537.544 150.521 551.548C159.412 565.953 168.344 575.313 171.904 573.4L302.505 502.787C298.83 504.777 289.436 494.733 280.27 479.55C267.802 489.589 255.262 499.357 243.377 510.395C243.377 510.395 240.629 508.887 239.558 509.198L239.568 509.183Z",
    fill: "#2866B1"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M278.181 504.156C279.021 506.393 281.508 507.54 283.745 506.699C285.983 505.859 287.129 503.373 286.289 501.135C285.449 498.898 282.962 497.751 280.725 498.591C278.487 499.431 277.341 501.918 278.181 504.156Z",
    fill: "#B3B3B3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M277.782 504.308C278.622 506.545 281.109 507.692 283.346 506.852C285.584 506.011 286.731 503.525 285.89 501.287C285.05 499.05 282.564 497.903 280.326 498.743C278.088 499.583 276.942 502.07 277.782 504.308Z",
    fill: "#E6E6E6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M267.481 510.658C268.321 512.895 270.807 514.042 273.045 513.201C275.282 512.361 276.429 509.875 275.589 507.637C274.749 505.4 272.262 504.253 270.024 505.093C267.787 505.933 266.64 508.42 267.481 510.658Z",
    fill: "#B3B3B3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M267.095 510.807C267.935 513.044 270.421 514.191 272.659 513.351C274.897 512.511 276.043 510.024 275.203 507.786C274.363 505.549 271.876 504.402 269.639 505.243C267.401 506.083 266.254 508.569 267.095 510.807Z",
    fill: "#E6E6E6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M257.221 517.077C258.061 519.315 260.548 520.461 262.785 519.621C265.023 518.781 266.169 516.294 265.329 514.056C264.489 511.819 262.002 510.672 259.765 511.513C257.527 512.353 256.381 514.839 257.221 517.077Z",
    fill: "#B3B3B3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M256.822 517.229C257.662 519.467 260.149 520.613 262.387 519.773C264.624 518.933 265.771 516.446 264.93 514.209C264.09 511.971 261.604 510.825 259.366 511.665C257.129 512.505 255.982 514.992 256.822 517.229Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M322.082 413.108C322.52 410.671 316.958 385.715 309.991 379.67C330.022 379.013 339.479 374.796 338.035 363.951C343.483 363.799 343.612 372.144 343.612 372.144C343.612 372.144 348.288 364.415 347.986 365.37C347.683 366.325 347.118 384.11 343.367 388.093C339.615 392.075 330.425 401.127 331.511 404.855C332.597 408.583 333.985 411.355 337.556 409.728C341.127 408.1 345.913 406.705 351.299 396.467C356.685 386.228 359.166 382.902 359.166 382.902C359.166 382.902 352.452 405.374 348.05 408.111C343.648 410.848 334.854 416.308 344.352 425.087C352.7 420.038 362.223 414.08 367.044 406.895C360.548 416.303 353.074 419.355 356.413 423.875C352.126 425.998 350.744 425.239 350.744 425.239C350.744 425.239 340.753 434.518 335.339 428.879C327.98 428.427 322.06 413.126 322.06 413.126L322.082 413.108Z",
    fill: "#FCC39E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_8626",
    x1: 329.859,
    y1: 92.635,
    x2: 757.592,
    y2: -0.445484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F6D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_692_8626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(337.183 405.285) rotate(159.563) scale(22.4126 31.1286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC39E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.db44864b59e5985841a8da4e9aad0367.svg";
export { ForwardRef as ReactComponent };